import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Table,
  Modal,
  InputNumber,
  notification,
} from 'antd'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import { SearchOutlined } from '@ant-design/icons'

import { getCookie } from 'helper/cookie'

import {
  getResultKPIFinance,
  addKPIFinance,
  goalKPIFinance,
  cleanKpi,
} from 'api/Project/kpifinance'
import { useForm } from 'antd/lib/form/Form'

import lang from 'lang/en'
import { Item } from 'gg-editor'
import { doc } from 'prettier'

const Container = styled.div`
  background-color: ${ColorList.white};

  width: 100;
  height: auto;
  margin-top: 16px;
  margin-left: 4px;
`
import { toUpper } from 'lodash'
const initalState = {
  data: [],
  isLoading: true,
}

const AddTaskKPIFinance = (props) => {
  const {
    idEditPRJ,
    visableModalTaskGoals,
    setVisableModalTaskGoals,
    data,
    getResultKpi,
    idtask,
    type,
  } = props

  const language = getCookie('lang')
  const word = lang[language]

  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')

  // const [visableModal, setVisableModal] = useState(false)
  const [form] = Form.useForm()

  const openNotificationWithIcon = (type, data) => {
    notification[type]({
      message: 'Success',
      description: 'You have been updated.',
      duration: 3,
    })
  }

  const handleClearValue = () => {
    setVisableModalTaskGoals(false)
    const dataArray = {
      projectkpi_id: data.id,
      project_id: parseInt(idEditPRJ),
      sprintflow_id: idtask,
    }
    cleanKpi({
      token: token,
      params: dataArray,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (status == 200) {
          openNotificationWithIcon('success', data)
          form.setFieldsValue({
            taskgoals: null,
            companyCode: 0,
          })
          getResultKpi()
        }
      })
      .catch((error) => {
        // setDataKPIFinance([])
        // setDataTask([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const onFinishTaskGoals = (values) => {
    setVisableModalTaskGoals(false)
    if (values.taskgoals == null) { //values.taskgoals == 0 || values.taskgoals == null
      const dataArray = {
        projectkpi_id: data.id,
        project_id: parseInt(idEditPRJ),
        sprintflow_id: idtask,
        // input_type_id: data.input_type_id,
        // goal: values.taskgoals,
      }
      cleanKpi({
        token: token,
        params: dataArray,
      })
        .then(async (response) => {
          const { status, data, error } = response
          if (status == 200) {
            openNotificationWithIcon('success', data)
            form.setFieldsValue({
              taskgoals: null,
              companyCode: 0,
            })
            getResultKpi()
          }
        })
        .catch((error) => {
          // setDataKPIFinance([])
          // setDataTask([])
          setIsLoading(false)
          console.error(error)
        })
    } else {
      const dataArray = {
        projectkpi_id: data.id,
        project_id: parseInt(idEditPRJ),
        sprintflow_id: idtask,
        input_type_id: data.input_type_id,
        goal: parseFloat(values.companyCode),
      }
      goalKPIFinance({
        token: token,
        params: dataArray,
      })
        .then(async (response) => {
          const { status, data, error } = response
          if (status == 200) {
            setVisableModalTaskGoals(false)
            openNotificationWithIcon('success', data)
            form.setFieldsValue({
              taskgoals: null,
              companyCode: 0,
            })
            getResultKpi()
          }
        })
        .catch((error) => {
          // setDataKPIFinance([])
          // setDataTask([])
          setIsLoading(false)
          console.error(error)
        })
    }
  }

  const [remaining, setRemining] = useState(0)
  const [taskgoal, setTaskgoal] = useState(0)

  useEffect(() => {
    setDisplayError('none')
    setDisplayRemaining('none')
    SetStyleError(
      'ant-row ant-form-item ant-form-item-with-help ant-form-item-has-success',
    )
    if (data) {
      if (data.sprintflow_goal == 0) {
        form.setFieldsValue({
          taskgoals: 0,
          companyCode: 0,
        })
        setTaskgoal(0)
      } else {
        form.setFieldsValue({
          taskgoals: data.sprintflow_goal,
          companyCode: data.sprintflow_goal,
        })
        setTaskgoal(data.sprintflow_goal)
      }
      let goalreal = ''
      let goremaining = ''
      if (data.sprintflow_parent_goal != 0) {
        //subtask ข้างบน
        goalreal =
          data.sprintflow_parent_goal - data.sprintflow_usegoal + data.sprintflow_goal
        goremaining = data.sprintflow_parent_goal - data.sprintflow_usegoal
      } else {
        //task ข้างบน subtask ข้างล่่าง
        let realusegoal = ''
        if (type == 'Sub') {
          realusegoal = data.sprintflow_usegoal
        } else {
          realusegoal = data.usegoal
        }
        if (data.sprintflow_goal == 0) {
          goalreal = data.goal - realusegoal
          goremaining = data.goal - realusegoal
        } else {
          goalreal = data.goal - realusegoal + data.sprintflow_goal
          // console.log(data.goal, realusegoal, data.sprintflow_goal)
          // console.log(`goalreal`, goalreal)

          goremaining = data.goal - realusegoal
        }
      }

      form.setFieldsValue({
        retaskgoals: goremaining.toFixed(2),
      })

      setRemining(goremaining)
    }
  }, [visableModalTaskGoals])

  const [disableBtn, setDisableBtn] = useState()
  const [displayError, setDisplayError] = useState()
  const [wordError, setWordError] = useState()
  const [styleError, SetStyleError] = useState()
  const [displayAlertRemaining, setDisplayRemaining] = useState('none')

  function Error() {
    setDisplayError('')
    setDisableBtn(true)
    SetStyleError('ant-row ant-form-item ant-form-item-with-help ant-form-item-has-error')
  }

  function Success() {
    setDisplayError('none')
    setDisableBtn(false)
    SetStyleError(
      'ant-row ant-form-item ant-form-item-with-help ant-form-item-has-success',
    )
  }

  // เอาปุ่มฝั่งขวาของ input ออก
  //   .ant-form-item .ant-input-number-handler-wrap {
  //     z-index: 2;
  //     display: none;
  // }

  const onChange = (value) => {
    if (value == '' || value == null) {
      form.setFieldsValue({
        retaskgoals: (remaining + taskgoal).toFixed(2),
      })
    } else if (typeof value == 'string') {
      form.setFieldsValue({
        retaskgoals: null,
      })
    } else {
      form.setFieldsValue({
        retaskgoals: (remaining + taskgoal - value).toFixed(2),
      })
    }

    let goalreal = ''
    if (data.sprintflow_parent_goal != 0) {
      //subtask ข้างบน
      goalreal =
        data.sprintflow_parent_goal - data.sprintflow_usegoal + data.sprintflow_goal
    } else {
      //task ข้างบน subtask ข้างล่่าง
      let realusegoal = ''
      if (type == 'Sub') {
        realusegoal = data.sprintflow_usegoal
      } else {
        realusegoal = data.usegoal
      }
      if (data.sprintflow_goal == 0) {
        goalreal = data.goal - realusegoal
      } else {
        goalreal = data.goal - realusegoal + data.sprintflow_goal
      }
    }

    if (value == '' || value == null) {
      form.setFieldsValue({
        companyCode: 0,
      })
    } else if (typeof value !== 'string') {
      form.setFieldsValue({
        companyCode: value.toFixed(2),
      })
    }

    // let split = `${value}`.split('.')
    // if (split[1]) {
    //   if (split[1].length > 2) {
    //     Error()
    //     setWordError(word['addtask_kpi_alert_modaltaskgoal_validamount'])
    //   } else if (value > goalreal) {
    //     setWordError(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
    //     Error()
    //   } else if (value === '') {
    //     Success()
    //   } else if (typeof value === 'string') {
    //     setWordError(word['addtask_kpi_alert_modaltaskgoal_validamount'])
    //     Error()
    //   } else {
    //     Success()
    //   }
    // } else
    // console.log(value, goalreal)

    // Check Task goal goals between goals */
    // if (value > goalreal.toFixed(2)) {
    //   setWordError(word['addtask_kpi_alert_modaltaskgoal_goalsbetween'])
    //   Error()
    // } else if (value === '') {
    if (value === '') {
      Success()
    } else if (typeof value === 'string') {
      setWordError(word['addtask_kpi_alert_modaltaskgoal_validamount'])
      Error()
    } else {
      Success()
    }

    // Check Task goal is less than subtask (Total subtask 0) */
    // if (value == '' || value == null) {
    //   setDisplayRemaining('none')
    // } else if (typeof value !== 'string') {
    //   if (value.toFixed(2) < data.sprintflowchild_usegoal) {
    //     setDisplayRemaining('')
    //   } else {
    //     setDisplayRemaining('none')
    //   }
    // }
  }

  return (
    <Modal
      maskClosable={false}
      title={
        <h2
          style={{ fontFamily: 'IBMPlexSansThaiBold' }}
          className="Modaltitle"
          id="kengAmsterdam"
        >
          {data.name}
        </h2>
      }
      visible={visableModalTaskGoals}
      onCancel={() => setVisableModalTaskGoals(false)}
      okText="Update"
      className="editmodal edit-width   dispalynoneupdowninputnumber"
      footer={null}
    >
      <Form form={form} onFinish={onFinishTaskGoals}>
        <Col span={24}>
          <Row>
            <h4 style={{ marginBottom: 8 }}>
              {type} {word['addtask_kpi_title_modaltaskgoal_taskgoal']} (
              {data.unit_type_name})
            </h4>

            <div
              style={{
                display: type == '' ? displayAlertRemaining : 'none',
                marginLeft: 8,
              }}
              class="ant-form-item-explain ant-form-item-explain-error"
            >
              <div role="alert">
                Task goal is less than subtask (Total subtask{' '}
                {data.sprintflowchild_usegoal})
              </div>
            </div>
          </Row>

          <Row gutter={32}>
            <Col span={12}>
              <Form.Item
                className={styleError}
                name="taskgoals"
                rules={[
                  {
                    pattern: /^-?[0-9]{1,16}(\.[0-9]{1,2})?$/,
                    message: word['Project_KPI/Finance_GoalMax'],
                  },
                  {
                    required: true,
                    message: word['Project_KPI/Finance_Goal'],
                  },
                ]}
                extra="Please enter your goals between goals"
              >
                <InputNumber
                  type="number"
                  className="border"
                  placeholder="Task goals"
                  size="large"
                  style={{ width: '100%' }}
                  // formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  // parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                  onChange={(e) => onChange(e)}
                  step="0.00"
                  max={9999999999999999.99}
                // maxLength={12}
                />
              </Form.Item>
              <div style={{ minHeight: 30 }}>
                <div
                  id="errorvalue"
                  style={{ display: displayError }}
                  class="ant-form-item-explain ant-form-item-explain-error"
                >
                  <div role="alert">{wordError}</div>
                </div>
              </div>
            </Col>
            <Col span={12}>
              <Row className="disableless">
                <h4 style={{ marginTop: 8 }}>Estimate ≈</h4>
                <Form.Item style={{ marginTop: 0 }} id="companyCode" name="companyCode">
                  <InputNumber
                    disabled
                    size="large"
                    style={{ width: '100%' }}
                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    step="0.00"
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Col style={{ width: '47%' }} className="disable-page">
            <h4 style={{ marginBottom: 8 }}>Remaining</h4>
            <Form.Item name="retaskgoals">
              {/* <InputNumber
                disabled
                size="large"
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                style={{ width: '100%' }}
                step="0.00"
                maxLength={12}
              /> */}
              <InputNumber
                disabled
                size="large"
                style={{ width: '100%' }}
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                step="0.00"
              />
            </Form.Item>
          </Col>
        </Col>

        {/* <Row gutter={20}>
          <Col span={6}>
            <div style={{ background: 'green' }}>col-6</div>
          </Col>
          <Col span={6}>
            <div style={{ background: 'green' }}>col-6</div>
          </Col>
          <Col span={6}>
            <div style={{ background: 'green' }}>col-6</div>
          </Col>
          <Col span={6}>
            <div style={{ background: 'green' }}>col-6</div>
          </Col>
        </Row> */}
        <div style={{ marginTop: 12, justifyContent: 'flex-end', display: 'flex' }}>
          <Button className="BTN_Warning" onClick={handleClearValue}>
            {word['addtask_kpi_title_modaltaskgoal_cancelvalue']}
          </Button>
          <Button
            className="BTN_Next"
            style={{ marginLeft: 8 }}
            onClick={form.submit}
            disabled={disableBtn}
          >
            {word['addtask_kpi_title_modaltaskgoal_update']}
          </Button>
        </div>
      </Form>
    </Modal>
  )
}
export default AddTaskKPIFinance
